import { render } from "./UgmMachineTabs.vue?vue&type=template&id=0baeaaba&scoped=true"
import script from "./UgmMachineTabs.vue?vue&type=script&lang=js"
export * from "./UgmMachineTabs.vue?vue&type=script&lang=js"

import "./UgmMachineTabs.vue?vue&type=style&index=0&id=0baeaaba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baeaaba"]])

export default __exports__